<template>
    <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <div style="display:flex;">
              <a-select
                show-search
                placeholder="Choose category"
                option-filter-prop="children"
                v-model="value"
                :filter-option="filterOption"
            >
                  <a-select-option v-for="category in cfilterCategoryategories" :key="category.id" v-bind:value="category.id">
                      {{category.name}}
                  </a-select-option>
              </a-select>
            
              <a-icon
                type="check"
                class="editable-cell-icon-check"
                @click="check"
              />
          </div>
            
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
</template>

<script>
    export default {
        name:'CategoryEditableCell',
        props: {
            text: String,
        },
        data() {
            return {
                value: this.text,
                editable: false,
                productId:"",
                categories: [
                  {
                    id:"1",
                    name:"Vaccine 1"
                  },
                  {
                    id:"2",
                    name:"Vaccine 2"
                  },
                  {
                    id:"3",
                    name:"Vaccine 3"
                  },
                ],
            };
        },
       
        methods: {
            filterOption(input, option) {
                  return (
                      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
            },
            handleChange(e) {
                console.log("e | ", e.target.value)
                const value = e.target.value;
                this.value = value;
            },
            check() {
                this.editable = false;
                // console.log("change | ", this.value)
                const value = this.categories.find(item => parseInt(item.id)  === parseInt(this.value));
                // console.log("target | ", target)
                this.$emit('change', value);
            },
            edit() {
                this.editable = true;
            },
        },
    }
</script>

<style scoped>
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 104px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

</style>